import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarDocumentFilterDropdownContent from './VeltCommentsSidebarDocumentFilterDropdownContent/VeltCommentsSidebarDocumentFilterDropdownContent';
import VeltCommentsSidebarDocumentFilterDropdownTrigger from './VeltCommentsSidebarDocumentFilterDropdownTrigger/VeltCommentsSidebarDocumentFilterDropdownTrigger';
var VeltCommentsSidebarDocumentFilterDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-document-filter-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarDocumentFilterDropdownWireframe.Trigger = VeltCommentsSidebarDocumentFilterDropdownTrigger;
VeltCommentsSidebarDocumentFilterDropdownWireframe.Content = VeltCommentsSidebarDocumentFilterDropdownContent;
export default VeltCommentsSidebarDocumentFilterDropdownWireframe;
